<template>
  <div>
    <swiper :options="swiperOption"  @slideChangeTransitionEnd="addDeaf" v-bind:key="rerender" ref="swiper">
    <template v-for='movie in movies'>
      <swiper-slide class="swipervideo" :data-video="'/videos/Ausstellung/' + movie.video" :data-audio="movie.audio" v-bind:key="movie.url">
        <img :data-src="srcpath + movie.url" class="swiper-lazy"/>
            <div class="swiper-lazy-preloader"></div>
      </swiper-slide>
    </template>
    </swiper>
    <videoplayer v-bind:postsrc="'/videos/Ausstellung/A1_HD_WEB.mp4'" v-if="this.$store.state.deaf == true" v-bind:autoplay="true"  class=""></videoplayer>
    <audioplayer v-bind:postsrc="'/mp3/' + src" v-if="this.$store.state.mute == true" v-bind:autoplay="true"  class=""></audioplayer>
    <div class="swiper-button-prev swiper-button-white" v-if="showSubMenu" slot="button-prev"></div>
    <div class="swiper-button-next swiper-button-white" v-if="showSubMenu" slot="button-next"></div>
  </div>
</template>

<style>
</style>

<script>
import s2data from '../../json/ausstellung.json'
import videoplayer from '@/components/Includes/videoplayerSmall.vue'
import audioplayer from '@/components/Includes/audioplayer.vue'
export default {
  name: 'ASSmain',
  components: {
    videoplayer,
    audioplayer
  },
  data () {
    return {
      movies: s2data,
      deaf: true,
      active: '',
      src: 'A-Audio.mp3',
      windowWidth: 0,
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 100,
        preloadImages: false,
        centeredSlides: true,
        lazy: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  computed: {
    srcpath () {
      if (this.$store.state.srcpath) {
        return '/img/ausstellung/'
      } else {
        return '/img/ausstellung/english/'
      }
    },
    rerender () {
      return this.$store.state.rerender
    },
    showSubMenu () {
      return this.$store.state.showSubMenu
    }
  },
  methods: {
    changeSliderPerView (perView) {
      this.swiperOption.slidesPerView = perView
      this.$store.commit('addUpRerender')
    },
    onChangeSlidePerView () {
      if (window.innerWidth <= 1024) {
        this.swiperOption.centeredSlides = false
        this.changeSliderPerView(1)
      } else if (window.innerWidth <= 1366) {
        this.swiperOption.centeredSlides = true
        this.changeSliderPerView(2)
      }
      if (window.innerWidth > 1700) {
        this.swiperOption.centeredSlides = true
        this.changeSliderPerView(3)
      }
    },
    addDeaf () {
      if (this.$store.state.deaf === true) {
        this.active = document.getElementsByClassName('swiper-slide-active')[0]
        document.getElementsByTagName('video')[0].src = this.active.dataset.video
        document.getElementsByTagName('video')[0].play()
      }
      if (this.$store.state.mute === true) {
        this.active = document.getElementsByClassName('swiper-slide-active')[0]
        if (this.src !== this.active.dataset.audio) {
          this.src = this.active.dataset.audio
          document.getElementsByTagName('video')[0].src = '/mp3/' + this.active.dataset.audio
          document.getElementsByTagName('video')[0].play()
        }
      }
    }
  },
  mounted () {
    this.onChangeSlidePerView()
    window.addEventListener('resize', this.onChangeSlidePerView)
    document.body.style.background = 'rgb(92, 192, 202)'
    // change color
    document.getElementsByTagName('nav')[0].style.background = 'rgb(92, 192, 202)'
    // showsubmenu
    this.$store.commit('toggleMenu', true)
  }
}
</script>

<style scoped>
.swiper-container{
  margin-top:100px;
  overflow: hidden;
  margin-right:50px;
  height: 100vh;
  z-index:3;
}

.swiper-button-prev{
  margin-left:100px;
  z-index:20;
}

.swiper-button-next{
  margin-right: 125px;
  z-index:20;
}

.swiper-slide img{
  height:90vh;
}
.swiper-deaf{
  height:60vh !important;
  margin-left: 120px;
  margin-bottom:-370px;
}
.swiper-pagination{
  margin-top:200px;
}

.wrapper{
  margin-top:0px;
}
@media (orientation: landscape) and (max-width: 980px) {

.swiper-slide img{
  height:99vh;
}

.swiper-container{
  margin-top: 0px;
  margin-left:0px;
}

.swiper-deaf{
  height:99vh !important;
  margin-left: 0px;
  margin-bottom:0px;
}

}

@media only screen and (orientation: portrait){
  .swiper-container{
    margin-top: 0px;
    margin-left:0px;
  }
}
@media only screen and (min-device-width: 320px) and (max-device-height: 568px) and (orientation : portrait){

  .swiper-slide img{
    margin-left: 65px;
    margin-bottom:0px;
    height:430px;
  }

  .swiper-deaf{
    display: block;
    margin-left:110px !important;
    margin-right: auto;
    height:177px !important;
  }

}

@media only screen and (min-device-width: 360px) and (max-device-height: 640px) and (orientation : portrait){

  .swiper-slide img{
    margin-left: 65px;
    margin-bottom:0px;
    height:430px;
  }

  .swiper-deaf{
    display: block;
    margin-left:120px !important;
    margin-right: auto;
    height:225px !important;
  }
}

@media only screen and (min-device-width: 375px) and (max-device-height: 812px) and (orientation : portrait){
  .swiper-container{
    margin-right:0;
  }
  .swiper-slide img{
    margin-left: 35px;
    margin-bottom:0px;
    height:595px;
  }

  .swiper-deaf{
    display: block;
    margin-left:85px !important;
    margin-right: auto;
    height:385px !important;
  }
}

@media only screen and (min-device-width: 375px) and (max-device-height: 667px) and (orientation : portrait){
  .swiper-slide img{
    margin-left: 65px;
    margin-bottom:0px;
    height:450px;
  }

  .swiper-deaf{
    display: block;
    margin-left:125px !important;
    margin-right: auto;
    height:240px !important;
  }
}

@media only screen and (min-device-width: 411px) and (max-device-height: 823px) and (orientation : portrait){

  .swiper-container{
    margin-right:0;
  }

  .swiper-slide img{
    margin-left: 55px;
    margin-bottom:0px;
    height:595px;
  }

  .swiper-deaf{
    display: block;
    margin-left:110px !important;
    margin-right: auto;
    height:360px !important;
  }
}

@media only screen and (min-device-width: 411px) and (max-device-height: 731px) and (orientation : portrait){

  .swiper-container{
    margin-right:0;
  }

  .swiper-slide img{
    margin-left: 75px;
    margin-bottom:0px;
    height:500px;
  }

  .swiper-deaf{
    display: block;
    margin-left:125px !important;
    margin-right: auto;
    height:270px !important;
  }
}

@media only screen and (min-device-width: 414px) and (max-device-height: 736px) and (orientation : portrait){
  .swiper-slide img{
    margin-left: 75px;
    margin-bottom:0px;
    height:506px;
  }

  .swiper-deaf{
    display: block;
    margin-left:130px !important;
    margin-right: auto;
    height:272px !important;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-height: 1024px) and (orientation : portrait){
  .swiper-slide img{
    margin-left: 170px;
    margin-bottom:0px;
    height:800px;
  }

  .swiper-deaf{
    display: block;
    margin-left:230px !important;
    margin-right: auto;
    height:540px !important;
  }
}

@media only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (orientation : portrait){
  .swiper-container{
    margin-top:100px;
    margin-right:0;
  }
  .swiper-slide img{
    margin-left: 0px;
    margin-bottom:0px;
    height:1200px;
  }

  .swiper-deaf{
    display: block;
    margin-left:80px !important;
    margin-right: auto;
    height:920px !important;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-height: 1024px) and (orientation : landscape){

  .swiper-deaf{
    display: block;
    margin-left:10px;
    margin-right: auto;
    height:470px !important;
  }
}

@media only screen and (min-device-width: 1366px) and (max-device-height: 1024px) and (orientation : landscape){

  .swiper-deaf{
    display: block;
    margin-left:10px;
    margin-right: auto;
    height:660px !important;
  }
}

</style>
